


























































import { Component, Mixins, Prop, PropSync } from 'vue-property-decorator';
import APP_UTILITIES from '@/utilities/commonFunctions';


import { CatalogSession, SessionBillingCycle, DiscountUnitsEnum } from '@/Model/sessions/catalogTypes';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import { ScreenText } from '@/lang/ScreenText';
import { getInstallmentsWithMakeupOnFinalInstallment } from '@/services/checkout/cart/helpers';

@Component
export default class SessionPriceTag extends Mixins(DeviceWidthCheckerMixin) {
  @Prop({ type: Object, required: true }) readonly session!: CatalogSession;
  @Prop({ type: Number, default: 1, required: false }) readonly quantity!: number;
  @PropSync('isAutomaticDiscountEnabled', { type: Boolean }) isAutomaticDiscountEnabledSync!: boolean;

  readonly screenText = new ScreenText();
  /**
   * TODO: Remove this when integrating with the BE
   * This is only for presentational purposes, in the integration stage this value should be read from the session object
  */
  readonly discountAmount = 50;
  unitDiscount = DiscountUnitsEnum.FixedAmount;

  get isRecurringPayment(): boolean {
    return [SessionBillingCycle.Weekly, SessionBillingCycle.Monthly].includes(this.session.sessionBillingCycle);
  }

  get finalDiscountPrice(): string {
    return this.isRecurringPayment
      ? this.getRawPrice(this.discountAmount, this.unitDiscount) + '/' + this.getRecurringPaymentUnit()
      : this.getRawPrice(this.discountAmount, this.unitDiscount);
  }
  /*
    TODO: This should be refactored based on the backend response
    discountAmount should be a string or a number ?
    will we received the discount amount as a number or a string including the unit discount (fixed amount or percentage)?
  */
  getRawPrice(discountAmount = 0, discountUnit = DiscountUnitsEnum.FixedAmount): string {
    const priceValue = ((this.isRecurringPayment)
      ? getInstallmentsWithMakeupOnFinalInstallment(this.session.price - discountAmount, this.session.billingCycleCount)[0] * this.quantity
      : this.session.price  * this.quantity
    );


    if (this.isRecurringPayment) {
      return APP_UTILITIES.currencyFmt.format(priceValue);
    }

    if (discountUnit === DiscountUnitsEnum.FixedAmount) {
      const fixedAmountDiscountCalc = priceValue - discountAmount * this.quantity;
      const finalAmountDiscountCalc = fixedAmountDiscountCalc > 0
        ? fixedAmountDiscountCalc
        : 0;
      return APP_UTILITIES.currencyFmt.format(finalAmountDiscountCalc);
    }

    return discountUnit === DiscountUnitsEnum.FixedAmount.toString()
      ? APP_UTILITIES.currencyFmt.format((priceValue - discountAmount) || 0)
      : APP_UTILITIES.currencyFmt.format((priceValue - priceValue * (discountAmount / 100)) || 0);
  }

  get formattedPrice(): string {
    const formattedPrice = this.getRawPrice(0, this.unitDiscount);
    return this.isRecurringPayment
      ? formattedPrice + '/' + this.getRecurringPaymentUnit()
      : formattedPrice;
  }

  getRecurringPaymentUnit(): string {
    return this.session.sessionBillingCycle === SessionBillingCycle.Weekly
      ? this.screenText.getScreenText('PRICE_RECURRING_WEEKLY_ABBREVIATION')
      : this.screenText.getScreenText('PRICE_RECURRING_MONTHLY_ABBREVIATION');
  }

  get formattedPerChildText(): string {
    const sessionPrice = APP_UTILITIES.currencyFmt.format(this.session.price);
    const perChildText = this.screenText.getScreenText('CHECKOUT_PER_CHILD');
    return `${sessionPrice} ${perChildText}`;
  }

  get tooltipText(): string {
    let text = '';
    if (this.session.price === 0 || this.discountAmount >= this.session.price) {
      text = this.screenText.getScreenText('PRICE_TOOLTIP_FREE');
    }
    else if (this.isRecurringPayment) {
      text = this.screenText.getScreenText('PRICE_TOOLTIP_RECURRING');
    }
    return text;
  }

  get recurringTotalText(): string {
    const totalAmount = this.session.price - this.discountAmount * this.quantity;
    const formattedTotalAmount = APP_UTILITIES.currencyFmt.format(totalAmount);
    return `${formattedTotalAmount} ${this.screenText.getScreenText('PRICE_RECURRING_TOTAL')}`;
  }

  get recurringPaymentCountText(): string {
    return `${this.session.billingCycleCount} ${this.screenText.getScreenText('PRICE_RECURRING_PAYMENTS')}`;
  }

  get originalPriceFormatted(): string {
    return `${APP_UTILITIES.currencyFmt.format(this.session.price)} ${this.screenText.getScreenText('PRICE_RECURRING_TOTAL')}`;
  }
}

